import { render, staticRenderFns } from "./CapCubeLayout.vue?vue&type=template&id=1b4854ff&scoped=true"
import script from "./CapCubeLayout.vue?vue&type=script&lang=js"
export * from "./CapCubeLayout.vue?vue&type=script&lang=js"
import style0 from "./CapCubeLayout.vue?vue&type=style&index=0&id=1b4854ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4854ff",
  null
  
)

export default component.exports